import { render, staticRenderFns } from "./VisitaRegistra.vue?vue&type=template&id=eb1c5f20&"
import script from "./VisitaRegistra.vue?vue&type=script&lang=js&"
export * from "./VisitaRegistra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports